import { render, staticRenderFns } from "./BooleanValueInput.vue?vue&type=template&id=147663ac&"
import script from "./BooleanValueInput.vue?vue&type=script&lang=js&"
export * from "./BooleanValueInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports